import React, { useEffect, useState } from "react";
import { Flex, Typography, Spin, Avatar } from "antd";
import { ArrowRightOutlined, PaperClipOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import moment from "moment";
import orderService from "../../services/OrderLists";

const { Text } = Typography;

const RecentComments = () => {
  const { orderKey } = useParams();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const res = await orderService.getOrderComments(orderKey);
        if (res?.success) {
          const payload = res.data?.data || res.data || {};
          const internal = (payload.internal_comments || []).map((c) => ({
            ...c,
            _source: "Internal",
          }));
          const client = (payload.client_comments || []).map((c) => ({
            ...c,
            _source: "Client",
          }));
          const all = [...internal, ...client].sort(
            (a, b) => new Date(b.submit_date) - new Date(a.submit_date)
          );
          setComments(all.slice(0, 3));
        }
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [orderKey]);

  const handleViewAll = () => {
    window.dispatchEvent(new CustomEvent("order-detail-switch-tab", { detail: "3" }));
  };

  return (
    <div>
      <Flex justify="flex-end" style={{ marginBottom: 8 }}>
        <Flex align="center" gap={4} style={{ cursor: "pointer" }} onClick={handleViewAll}>
          <Text style={{ color: "#1890ff", fontSize: 12 }}>View All</Text>
          <ArrowRightOutlined style={{ fontSize: 11, color: "#1890ff" }} />
        </Flex>
      </Flex>

      {loading ? (
        <Flex justify="center" style={{ padding: 16 }}>
          <Spin size="small" />
        </Flex>
      ) : comments.length === 0 ? (
        <Text type="secondary" style={{ fontSize: 13 }}>No comments yet.</Text>
      ) : (
        <Flex vertical gap={8}>
          {comments.map((c, i) => {
            const name = typeof c.user === "string" ? c.user : (c.user?.full_name || c.user?.username || "Unknown");
            const initials = name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);
            const files = c.uploaded_files || [];

            return (
              <div
                key={i}
                style={{
                  background: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: 6,
                  padding: "10px 12px",
                }}
              >
                <Flex justify="space-between" align="flex-start" wrap="wrap" gap={4}>
                  <Flex gap={8} align="center">
                    <Avatar size={28} style={{ background: "#1890ff", fontSize: 11, flexShrink: 0 }}>
                      {initials}
                    </Avatar>
                    <Flex vertical gap={0}>
                      <Text strong style={{ fontSize: 12 }}>{name}</Text>
                      <Text type="secondary" style={{ fontSize: 11 }}>{c._source} Comment</Text>
                    </Flex>
                  </Flex>
                  <Text type="secondary" style={{ fontSize: 11, whiteSpace: "nowrap" }}>
                    {c.submit_date ? moment(c.submit_date).format("DD-MM-YYYY hh:mm A") : ""}
                  </Text>
                </Flex>

                {c.comment && (
                  <Text
                    style={{
                      fontSize: 13,
                      display: "block",
                      marginTop: 6,
                      color: "#333",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {c.comment.length > 200 ? `${c.comment.slice(0, 200)}...` : c.comment}
                  </Text>
                )}

                {files.length > 0 && (
                  <Flex vertical gap={4} style={{ marginTop: 6 }}>
                    {files.map((f, fi) => (
                      <Flex key={fi} align="center" gap={6}>
                        <PaperClipOutlined style={{ color: "#1890ff", fontSize: 12 }} />
                        <a
                          href={f.file_url}
                          target="_blank"
                          rel="noreferrer"
                          style={{ fontSize: 12, color: "#1890ff" }}
                        >
                          {f.title || `File ${fi + 1}`}
                        </a>
                      </Flex>
                    ))}
                  </Flex>
                )}
              </div>
            );
          })}
        </Flex>
      )}
    </div>
  );
};

export default RecentComments;
